import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const OrderTrackingShipmentSummarySchema_ = z.object({
  _id: z.string(),
  orderId: z.string(),
  orderName: z.string().nullish(),
  customerName: z.string().nullish(),
  customerEmail: z.string().nullish(),
  orderDate: z.date().nullish(),
  status: z.string().nullish(),
  trackingNumber: z.string().nullish(),
  carrier: z.string().nullish(),
  deliveryStatus: z.string().nullish(),
  shippedAt: z.date().nullish(),
  estimatedDeliveryAt: z.date().nullish(),
});

export const OrderTrackingShipmentSummarySchema: z.ZodType<OrderTrackingShipmentSummary> =
  OrderTrackingShipmentSummarySchema_;
export interface OrderTrackingShipmentSummary
  extends z.infer<typeof OrderTrackingShipmentSummarySchema_> {}

export const orderTrackingShipmentSortKeys = [
  "orderName",
  "customerName",
  "customerEmail",
  "orderDate",
  "status",
  "trackingNumber",
  "carrier",
  "deliveryStatus",
  "shippedAt",
  "estimatedDeliveryAt",
] as const;

export type OrderTrackingShipmentSortKey =
  (typeof orderTrackingShipmentSortKeys)[number];

const sortKeyEnum = z.enum(orderTrackingShipmentSortKeys);

export const getOrderTrackingShipments = {
  name: "getOrderTrackingShipments" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(50),
    sortKey: sortKeyEnum.default("shippedAt"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchString: z.string().optional(),
  }),
  output: z.object({
    shipments: z.array(OrderTrackingShipmentSummarySchema),
    totalCount: z.number(),
  }),
};
